import React from 'react';
import { Star } from 'lucide-react';

export const PersonFlag = ({ status, isArchived }) => {
  if (isArchived)
    return (
      <span className="text-[9px] uppercase text-gray-400 border border-gray-600 rounded px-1 py-px">
        Archived
      </span>
    );
  if (status === 'inactive')
    return (
      <span className="text-[9px] uppercase text-amber-400/80 border border-amber-800 rounded px-1 py-px">
        Inactive
      </span>
    );
  return null;
};

export const AssigneeChips = ({ assignees, max = 3 }) => {
  if (!assignees || assignees.length === 0) {
    return (
      <span className="text-[11px] text-gray-600 italic" data-testid="assignees-unassigned">
        Unassigned
      </span>
    );
  }
  const shown = assignees.slice(0, max);
  const extra = assignees.length - shown.length;
  return (
    <div className="flex flex-wrap items-center gap-1" data-testid="assignee-chips">
      {shown.map((a) => (
        <span
          key={a.assignment_id}
          className="inline-flex items-center gap-1 text-[10px] bg-[#1F1F1F] border border-gray-700 text-gray-300 rounded-full px-2 py-0.5"
        >
          {a.is_primary && <Star size={9} className="text-[#D4AF37] fill-[#D4AF37]" />}
          {a.display_name}
          <PersonFlag status={a.person_status} isArchived={a.person_is_archived} />
        </span>
      ))}
      {extra > 0 && <span className="text-[10px] text-gray-500">+{extra}</span>}
    </div>
  );
};
